import { useTranslation } from '@hooks/useTranslation';
import { formatRubyAmount, gtagEventTrigger } from '@specs/helpers';
import { StoreItemView } from '@specs/views';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { Button, ButtonProps } from '@components/UIKit/Button/Button';
import { LinksEnum } from '@specs/navigation';
import { toy } from '@specs/specs';
import { useToysCart } from '@hooks/useToysCart';
import { useShowToast } from '@hooks/useShowToast';
interface Props extends Omit<ButtonProps, 'children'> {
  firstStoreItem: Omit<StoreItemView, 'instanceid'> & {
    instanceid: number;
  };
  toyName: toy['name'];
}
export const BuyToyButton: FC<Props> = ({
  firstStoreItem,
  toyName,
  ...props
}) => {
  const {
    translate: tr
  } = useTranslation();
  const {
    showToast
  } = useShowToast();
  const router = useRouter();
  const {
    addToCartHandler,
    isInCartState
  } = useToysCart({
    toyId: firstStoreItem?.toyid ?? -1
  });
  const goToCartHandler = async () => {
    gtagEventTrigger({
      action: 'go_to_basket',
      category: 'commercial'
    });
    await router.push(LinksEnum.CART_TOYS);
  };
  const {
    currency,
    price
  } = firstStoreItem;
  const currentPrice = currency === 'RUBY' ? formatRubyAmount(price) : price;
  return <>
            {!isInCartState ? <Button {...props} onClick={() => {
      const result = addToCartHandler(firstStoreItem);
      if (result) {
        showToast({
          variant: 'info',
          title: tr({
            id: 'toy.page.added.to.cart.title'
          }, {
            name: toyName
          }),
          text: 'toy.page.added.to.cart.description',
          icon: {
            name: 'cart'
          }
        });
      }
    }} icons={{
      left: {
        name: currency === 'GOLD' ? 'gold' : 'ruby'
      }
    }}>
                    {currentPrice}
                </Button> : <Button {...props} color={'White'} onClick={goToCartHandler} icons={{
      left: {
        name: 'cart'
      }
    }}>
                    {tr({
        id: 'btn.go.to.cart'
      })}
                </Button>}
        </>;
};